/**
 * Crocin Labs — Quiz Popup (3-step)
 * Welcome → Question → Email (Shopify native form) → Success
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cq_quiz_submitted';

  function init() {
    var section = document.querySelector('.crowson-quiz');
    if (!section || section.dataset.cqInit === '1') return;
    section.dataset.cqInit = '1';

    try { if (localStorage.getItem(STORAGE_KEY) === '1') return; } catch (e) {}

    var overlay = section.querySelector('.crowson-quiz__overlay');
    if (!overlay) return;

    var state = { step: 0, goal: null, fired: false };

    overlay.querySelector('.crowson-quiz__close').addEventListener('click', function () { closePopup(overlay); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closePopup(overlay);
    });

    overlay.querySelectorAll('[data-action="next"]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(overlay, state, 1); });
    });

    overlay.querySelectorAll('[data-action="close"]').forEach(function (btn) {
      btn.addEventListener('click', function () { closePopup(overlay); });
    });

    overlay.querySelectorAll('.crowson-quiz__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        overlay.querySelectorAll('.crowson-quiz__option').forEach(function (o) { o.removeAttribute('data-selected'); });
        btn.setAttribute('data-selected', 'true');
        state.goal = btn.dataset.value;
        updateTagsField(overlay, state);
        setTimeout(function () { goToStep(overlay, state, 2); }, 250);
      });
    });

    overlay.querySelectorAll('.crowson-quiz__back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = parseInt(btn.dataset.targetStep, 10);
        if (!isNaN(t)) goToStep(overlay, state, t);
      });
    });

    var form = overlay.querySelector('.crowson-quiz__form');
    if (form) {
      setupFormSubmission(form, overlay, state);
    }

    var POPUP_DELAY = 15000;
    setTimeout(function () {
      if (!state.fired) {
        state.fired = true;
        openPopup(overlay);
      }
    }, POPUP_DELAY);
  }

  function openPopup(overlay) {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(overlay) {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function goToStep(overlay, state, step) {
    state.step = step;
    overlay.querySelectorAll('.crowson-quiz__step').forEach(function (s, i) {
      s.dataset.active = (i === step) ? 'true' : 'false';
    });
    overlay.querySelectorAll('.crowson-quiz__progress-dot').forEach(function (dot, i) {
      dot.setAttribute('data-active', (i === step) ? 'true' : 'false');
      dot.setAttribute('data-complete', (i < step) ? 'true' : 'false');
    });
  }

  function updateTagsField(overlay, state) {
    var tagsField = overlay.querySelector('#cq-tags-field');
    if (!tagsField) return;
    var tags = ['newsletter', 'quiz-respondent'];
    if (state.goal) tags.push('quiz-goal-' + state.goal);
    tagsField.value = tags.join(', ');
  }

  function setupFormSubmission(form, overlay, state) {
    form.addEventListener('submit', function () {
      updateTagsField(overlay, state);
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.crowson-quiz')) {
      init();
    }
  });
})();
